import React from "react";
import {Link} from "react-router-dom";

function NotFoundPage() {

    return (
        <div>

            <h1>404<br/><br/>
            The page that you're looking for was not found</h1><br/>
            <Link to={'/'}>
                Back to the homapage
            </Link>

        </div>
    );
}

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/components/NotFoundPage/NotFoundPage.jsx